import {TFunction} from "i18next";
import {MUIDataTableColumn} from "mui-datatables";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {IconButton} from "@mui/material";
import React from "react";

export function applicationUserGroupMemberColumns(
  t: TFunction,
  deleteMemberFunc: (membershipId: string) => void,
  readonly: boolean
): MUIDataTableColumn[] {
  return [
    {name: 'user.firstName', label: t('User.firstName'), options: {filter: false}},
    {name: 'user.lastName', label: t('User.lastName'), options: {filter: false}},
    {name: 'user.email', label: t('User.email'), options: {filter: false}},
    {
      name: "id", label: t('buttons.delete'), options: {
        display: !readonly,
        customBodyRender: (id) => <IconButton size="small" aria-label="remove" onClick={() => deleteMemberFunc(id)}>
          <DeleteOutlineOutlinedIcon/>
        </IconButton>,
        filter: false
      }
    }
  ];
}
